/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    "/admin/campaign/premium-start/update": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /** 编辑Premium Start活动（仅允许禁用状态下编辑） */
        put: operations["updateCampaignPremiumStartUpdate"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/promotion/internal/campaign/check-eligibility": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 查询用户可触达的活动列表（内部接口） */
        post: operations["createInternalCampaignCheckEligibility"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/campaign/reward/preview": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 奖励预览（根据币种和金额计算奖励预览值） */
        post: operations["createCampaignRewardPreview"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/campaign/participate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 参与活动（充值成功后触发） */
        post: operations["createCampaignParticipate"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/campaign/premium-start/enable/{campaignId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 启用活动 */
        post: operations["createPremiumStartEnableByCampaignId"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/campaign/premium-start/disable/{campaignId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 禁用/下线活动 */
        post: operations["createPremiumStartDisableByCampaignId"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/campaign/premium-start/create": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 创建Premium Start活动 */
        post: operations["createCampaignPremiumStartCreate"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/campaign/participation/query": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 查询用户活动参与记录（支持时间范围和活动名称筛选） */
        post: operations["createCampaignParticipationQuery"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/campaign/available": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 获取用户可用的活动列表（包含活动详细信息和素材） */
        get: operations["getCampaignAvailable"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/campaign/premium-start/{campaignId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 查看活动详情 */
        get: operations["getCampaignPremiumStartByCampaignId"];
        put?: never;
        post?: never;
        /** 删除活动 */
        delete: operations["deleteCampaignPremiumStartByCampaignId"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/campaign/premium-start/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 分页查询活动列表（支持筛选） */
        get: operations["getCampaignPremiumStartList"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/campaign/material/{materialId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 根据ID查询素材详情 */
        get: operations["getCampaignMaterialByMaterialId"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/campaign/material/list/available": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 查询所有可用素材列表（供创建活动时选择） */
        get: operations["getMaterialListAvailable"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/campaign/affiliate/withdraw": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 提现至内部钱包 */
        post: operations["createCampaignAffiliateWithdraw"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/campaign/affiliate/total-wager-rewards": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 分页查询固定奖励列表 */
        post: operations["createCampaignAffiliateTotalWagerRewards"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/campaign/affiliate/commission-by-friends": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 按好友分页查询佣金贡献 */
        post: operations["createCampaignAffiliateCommissionByFriends"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/campaign/affiliate/rate-rules-config": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 获取返佣比率与规则配置 */
        get: operations["getCampaignAffiliateRateRulesConfig"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/campaign/affiliate/my-rewards/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 获取我的奖励汇总 */
        get: operations["getAffiliateMyRewardsSummary"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/campaign/affiliate/live-rewards": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 获取滚屏奖励数据 */
        get: operations["getCampaignAffiliateLiveRewards"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/campaign/affiliate/invite/code/stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 获取邀请码统计列表 */
        get: operations["getCampaignAffiliateInviteCodeStats"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/campaign/affiliate/dashboard/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 获取Dashboard汇总 */
        get: operations["getAffiliateDashboardSummary"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/campaign/redemptionCode/useRedemptionCode": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 使用兑换码
         * @description 失败：INVALID_CODE、EXPIRED_CODE、CODE_USAGE_LIMIT、ALREADY_CODE
         */
        post: operations["createCampaignRedemptionCodeUseRedemptionCode"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        /** @description 后台更新活动请求（仅允许禁用状态下编辑） */
        AdminCampaignUpdateRequest: {
            /**
             * @description 活动ID
             * @example campaign_123456
             */
            campaignId: string;
            /**
             * @description 活动名称
             * @example 春节首充活动
             */
            campaignName: string;
            /**
             * Format: int32
             * @description 优先级（数字越小越高，0最高）
             * @example 1
             */
            priority: number;
            /**
             * @description 用户标签分组名称（为空表示全量用户）
             * @example vip_user
             */
            userTag?: string;
            /**
             * @description 国家/地区代码列表（为空表示全量）
             * @example [
             *       "US",
             *       "CN"
             *     ]
             */
            countries?: string[];
            /**
             * Format: date-time
             * @description 活动开始时间
             */
            startTime: string;
            /**
             * Format: date-time
             * @description 活动结束时间
             */
            endTime: string;
            triggerRule: components["schemas"]["TriggerRuleDTO"];
            rewardRule: components["schemas"]["RewardRuleDTO"];
            /**
             * @description 关联的素材ID（Banner）
             * @example material_001
             */
            materialId?: string;
            /**
             * @description 素材展示位置
             * @example lobby_banner
             */
            materialPosition?: string;
        };
        /** @description 奖励规则 */
        RewardRuleDTO: {
            /**
             * @description 奖励类型（bet_credits-投注积分）
             * @example bet_credits
             */
            rewardType: string;
            /**
             * @description 领取方式（auto_collect-自动发放, manual_collect-手动领取）
             * @example auto_collect
             */
            collectType: string;
            /**
             * @description 最小充值金额（美元）
             * @example 5
             */
            minDepositAmount: number;
            /**
             * @description 最大充值金额（美元，为空表示无上限）
             * @example 100
             */
            maxDepositAmount?: number;
            /**
             * @description 奖励百分比（如200表示200%）
             * @example 200
             */
            rewardPercentage: number;
        };
        /** @description 触发规则 */
        TriggerRuleDTO: {
            /**
             * @description 触发事件列表（deposit_page-充值页, lobby_enter-大厅）
             * @example [
             *       "deposit_page",
             *       "lobby_enter"
             *     ]
             */
            triggerEvents: string[];
            /**
             * @description 是否支持同时触发多个活动
             * @example true
             */
            allowConcurrent?: boolean;
        };
        /** @description 后台活动响应 */
        AdminCampaignResponse: {
            /**
             * @description 活动ID
             * @example campaign_123456
             */
            campaignId: string;
            /**
             * @description 活动名称
             * @example 春节首充活动
             */
            campaignName: string;
            /**
             * @description 活动类型
             * @example first_deposit
             */
            campaignType: string;
            /**
             * @description 活动类型显示名称
             * @example Premium Start
             */
            campaignTypeDisplayName: string;
            /**
             * @description 活动类型中文名称
             * @example 溢价充值活动
             */
            campaignTypeChineseName: string;
            /**
             * Format: int32
             * @description 优先级
             * @example 1
             */
            priority: number;
            /**
             * @description 活动状态（active-已上线, disabled-已下线, expired-已过期）
             * @example active
             */
            status: string;
            /**
             * @description 活动状态显示名称
             * @example 进行中
             */
            statusDisplayName: string;
            /**
             * @description 用户标签分组名称
             * @example vip_user
             */
            userTag: string;
            /**
             * @description 国家/地区代码列表
             * @example [
             *       "US",
             *       "CN"
             *     ]
             */
            countries: string[];
            /**
             * @description 终端类型
             * @example web
             */
            productType: string;
            /**
             * Format: date-time
             * @description 开始时间
             */
            startTime: string;
            /**
             * Format: date-time
             * @description 结束时间
             */
            endTime: string;
            /**
             * @description 最小充值金额（美元）
             * @example 5
             */
            minDepositAmount: number;
            /**
             * @description 最大充值金额（美元）
             * @example 100
             */
            maxDepositAmount: number;
            /**
             * @description 奖励百分比
             * @example 200
             */
            rewardPercentage: number;
            /**
             * @description 奖励类型
             * @example bet_credits
             */
            rewardType: string;
            /**
             * @description 奖励类型显示名称
             * @example Bet Credits
             */
            rewardTypeDisplayName: string;
            /**
             * @description 礼包ID
             * @example reward_001
             */
            rewardId: string;
            /**
             * @description 是否可重复参与
             * @example false
             */
            repeatable: boolean;
            /**
             * @description 创建人
             * @example admin@example.com
             */
            createdBy: string;
            /**
             * Format: date-time
             * @description 创建时间
             */
            createdAt: string;
            /**
             * @description 更新人
             * @example admin@example.com
             */
            updatedBy: string;
            /**
             * Format: date-time
             * @description 更新时间
             */
            updatedAt: string;
            /**
             * @description 触发事件列表
             * @example [
             *       "deposit_page",
             *       "lobby_enter"
             *     ]
             */
            triggerEvents: string[];
            /**
             * @description 领取方式
             * @example auto_collect
             */
            collectType: string;
            material: components["schemas"]["MaterialInfo"];
        };
        /** @description 素材信息 */
        MaterialInfo: {
            /**
             * @description 素材ID
             * @example material_001
             */
            materialId: string;
            /**
             * @description 素材名称
             * @example 春节首充Banner
             */
            materialName: string;
            /**
             * @description 素材类型
             * @example banner
             */
            materialType: string;
            /**
             * @description 图片链接
             * @example https://cdn.example.com/banner.jpg
             */
            materialImg: string;
            /**
             * @description 展示位置
             * @example lobby_banner
             */
            position: string;
            /**
             * @description 展示位置显示名称
             * @example Lobby Banner
             */
            positionDisplayName: string;
        };
        SingleResponseAdminCampaignResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["AdminCampaignResponse"];
        };
        /** @description 活动资格校验请求 */
        CampaignEligibilityCheckRequest: {
            /**
             * Format: int64
             * @description 用户ID
             * @example 100001
             */
            userId: number;
            /**
             * @description 用户国家代码
             * @example US
             */
            country: string;
            /**
             * @description 触发位置（素材展示位置）
             * @example lobby_banner
             * @enum {string}
             */
            triggerPosition: "lobby_banner" | "deposit_popup_image" | "deposit_popup_title_text" | "email_header_image" | "activity_detail_banner";
        };
        /** @description 活动资格校验响应 */
        CampaignEligibilityCheckResponse: {
            /** @description 符合资格的活动列表（按优先级排序） */
            eligibleCampaigns: components["schemas"]["EligibleCampaign"][];
        };
        /** @description 符合资格的活动 */
        EligibleCampaign: {
            /**
             * @description 活动ID
             * @example campaign_123456
             */
            campaignId: string;
            /**
             * @description 活动名称
             * @example 春节首充活动
             */
            campaignName: string;
            /**
             * @description 活动类型
             * @example first_deposit
             */
            campaignType: string;
            /**
             * Format: int32
             * @description 活动优先级
             * @example 1
             */
            priority: number;
            /**
             * @description 活动状态
             * @example active
             */
            status: string;
            /**
             * Format: date-time
             * @description 活动开始时间
             */
            startTime: string;
            /**
             * Format: date-time
             * @description 活动结束时间
             */
            endTime: string;
            material: components["schemas"]["MaterialInfo"];
        };
        SingleResponseCampaignEligibilityCheckResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["CampaignEligibilityCheckResponse"];
        };
        /** @description 奖励预览请求 */
        RewardPreviewRequest: {
            /**
             * @description 活动ID
             * @example campaign_123456
             */
            campaignId: string;
            /**
             * @description 充值金额（可选，如果不传则使用活动最小配置金额）
             * @example 50
             */
            amount?: number;
            /**
             * @description 充值币种（可选，如果不传则使用USD）
             * @example EUR
             */
            currency?: string;
        };
        /** @description 奖励预览响应 */
        RewardPreviewResponse: {
            /**
             * @description 活动ID
             * @example campaign_123456
             */
            campaignId: string;
            /**
             * @description 充值金额
             * @example 50
             */
            depositAmount: number;
            /**
             * @description 充值币种
             * @example EUR
             */
            depositCurrency: string;
            /**
             * @description 奖励金额
             * @example 100
             */
            rewardAmount: number;
            /**
             * @description 奖励币种
             * @example EUR
             */
            rewardCurrency: string;
            /**
             * @description 奖励百分比
             * @example 200
             */
            rewardPercentage: number;
            /**
             * @description 总金额（充值金额+奖励金额）
             * @example 150
             */
            totalAmount: number;
            /**
             * @description 总金额币种
             * @example EUR
             */
            totalCurrency: string;
            /**
             * @description 最大充值金额（当未传入充值金额时返回）
             * @example 1000
             */
            maxDepositAmount: number;
            /**
             * @description 最大充值金额对应的奖励金额（当未传入充值金额时返回）
             * @example 2000
             */
            maxRewardAmount: number;
            /**
             * @description 最大充值金额对应的总金额（当未传入充值金额时返回）
             * @example 3000
             */
            maxTotalAmount: number;
        };
        SingleResponseRewardPreviewResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["RewardPreviewResponse"];
        };
        SingleResponseString: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: string;
        };
        /** @description 后台创建活动请求 */
        AdminCampaignCreateRequest: {
            /**
             * @description 活动名称
             * @example 春节首充活动
             */
            campaignName: string;
            /**
             * @description 活动类型（first_deposit-首充活动）
             * @example first_deposit
             */
            campaignType: string;
            /**
             * Format: int32
             * @description 优先级（数字越小越高，0最高）
             * @example 1
             */
            priority: number;
            /**
             * @description 用户标签分组名称（为空表示全量用户）
             * @example vip_user
             */
            userTag?: string;
            /**
             * @description 国家/地区代码列表（为空表示全量）
             * @example [
             *       "US",
             *       "CN"
             *     ]
             */
            countries?: string[];
            /**
             * @description 终端类型（目前固定web）
             * @example web
             */
            productType: string;
            /**
             * Format: date-time
             * @description 活动开始时间
             */
            startTime: string;
            /**
             * Format: date-time
             * @description 活动结束时间
             */
            endTime: string;
            triggerRule: components["schemas"]["TriggerRuleDTO"];
            rewardRule: components["schemas"]["RewardRuleDTO"];
            /**
             * @description 是否可重复参与
             * @example false
             */
            repeatable?: boolean;
            /**
             * @description 关联的素材ID（Banner）
             * @example material_001
             */
            materialId?: string;
            /**
             * @description 素材展示位置
             * @example lobby_banner
             */
            materialPosition?: string;
        };
        /** @description 后台活动参与记录查询请求 */
        AdminCampaignParticipationQueryRequest: {
            /**
             * @description 用户ID
             * @example 100001
             */
            userId: string;
            /**
             * @description 活动名称（模糊搜索）
             * @example 首充
             */
            campaignName?: string;
            /**
             * Format: date-time
             * @description 开始时间（筛选参与时间）
             */
            startTime?: string;
            /**
             * Format: date-time
             * @description 结束时间（筛选参与时间）
             */
            endTime?: string;
        };
        SingleResponseListUserCampaignParticipationResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["UserCampaignParticipationResponse"][];
        };
        /** @description 用户活动参与记录响应 */
        UserCampaignParticipationResponse: {
            /**
             * Format: date-time
             * @description 参与时间
             */
            participationTime: string;
            /**
             * @description 充值金额
             * @example 100
             */
            depositAmount: number;
            /**
             * @description 充值币种
             * @example EUR
             */
            depositCurrency: string;
            /**
             * @description 充值ID
             * @example order_123456
             */
            depositId: string;
            /**
             * @description 奖励类型
             * @example bet_credits
             */
            rewardType: string;
            /**
             * @description 奖励金额
             * @example 200
             */
            rewardAmount: number;
            /**
             * @description 活动ID
             * @example campaign_001
             */
            campaignId: string;
            /**
             * @description 活动名称
             * @example 春节首充200%
             */
            campaignName: string;
        };
        SingleResponseObject: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: Record<string, never>;
        };
        /** @description 后台活动详情响应 */
        AdminCampaignDetailResponse: {
            /**
             * @description 活动ID
             * @example campaign_123456
             */
            campaignId: string;
            /**
             * @description 活动名称
             * @example 春节首充活动
             */
            campaignName: string;
            /**
             * @description 活动类型
             * @example first_deposit
             */
            campaignType: string;
            /**
             * @description 活动类型显示名称
             * @example Premium Start
             */
            campaignTypeDisplayName: string;
            /**
             * @description 活动类型中文名称
             * @example 溢价充值活动
             */
            campaignTypeChineseName: string;
            /**
             * Format: int32
             * @description 优先级
             * @example 1
             */
            priority: number;
            /**
             * @description 活动状态（active-已上线, disabled-已下线, expired-已过期）
             * @example active
             */
            status: string;
            /**
             * @description 活动状态显示名称
             * @example 进行中
             */
            statusDisplayName: string;
            /**
             * @description 用户标签分组名称
             * @example vip_user
             */
            userTag: string;
            /**
             * @description 国家/地区代码列表
             * @example [
             *       "US",
             *       "CN"
             *     ]
             */
            countries: string[];
            /**
             * @description 终端类型
             * @example web
             */
            productType: string;
            /**
             * Format: date-time
             * @description 开始时间
             */
            startTime: string;
            /**
             * Format: date-time
             * @description 结束时间
             */
            endTime: string;
            triggerRule: components["schemas"]["TriggerRuleDTO"];
            rewardRule: components["schemas"]["RewardRuleDTO"];
            /**
             * @description 是否可重复参与
             * @example false
             */
            repeatable: boolean;
            material: components["schemas"]["MaterialInfo"];
            /**
             * @description 创建人
             * @example admin@example.com
             */
            createdBy: string;
            /**
             * Format: date-time
             * @description 创建时间
             */
            createdAt: string;
            /**
             * @description 更新人
             * @example admin@example.com
             */
            updatedBy: string;
            /**
             * Format: date-time
             * @description 更新时间
             */
            updatedAt: string;
        };
        SingleResponseAdminCampaignDetailResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["AdminCampaignDetailResponse"];
        };
        /** @description 后台查询活动请求 */
        AdminCampaignQueryRequest: {
            /**
             * @description 活动名称（模糊搜索）
             * @example 首充
             */
            campaignName: string;
            /**
             * @description 群组标签名称（模糊搜索）
             * @example vip
             */
            userTag: string;
            /**
             * @description 活动状态（active-已上线, disabled-已下线）
             * @example active
             */
            status: string;
            /**
             * @description 活动类型（first_deposit-首充活动）
             * @example first_deposit
             */
            campaignType: string;
            /**
             * Format: int32
             * @description 页码（从1开始）
             * @example 1
             */
            pageNum: number;
            /**
             * Format: int32
             * @description 每页大小
             * @example 10
             */
            pageSize: number;
        };
        /** @description 后台活动列表响应 */
        AdminCampaignListResponse: {
            /**
             * @description 活动ID
             * @example campaign_123456
             */
            campaignId: string;
            /**
             * @description 活动名称
             * @example 春节首充活动
             */
            campaignName: string;
            /**
             * @description 活动状态（active-进行中, disabled-已下线）
             * @example active
             */
            status: string;
            /**
             * @description 活动状态显示名称
             * @example 进行中
             */
            statusDisplayName: string;
            /**
             * Format: int32
             * @description 优先级
             * @example 1
             */
            priority: number;
            /**
             * @description 群组名称
             * @example vip_user
             */
            userTag: string;
            /**
             * @description 国家/地区（逗号分隔）
             * @example US, CN
             */
            country: string;
            /**
             * @description 设备类型
             * @example web
             */
            productType: string;
            /**
             * @description 充值金额/赠送比例（格式：$100 / 200%）
             * @example $5-$100 / 200%
             */
            depositAndReward: string;
            /**
             * Format: date-time
             * @description 开始时间
             */
            startTime: string;
            /**
             * Format: date-time
             * @description 结束时间
             */
            endTime: string;
            /**
             * @description 创建人
             * @example admin@example.com
             */
            createdBy: string;
            /**
             * Format: date-time
             * @description 创建时间
             */
            createdAt: string;
        };
        /** @description 分页结果 */
        PageResultAdminCampaignListResponse: {
            /**
             * Format: int64
             * @description 当前页
             */
            current: number;
            /**
             * Format: int64
             * @description 每页数量
             */
            size: number;
            /**
             * Format: int64
             * @description 总记录数
             */
            total: number;
            /** @description 数据列表 */
            records: components["schemas"]["AdminCampaignListResponse"][];
        };
        SingleResponsePageResultAdminCampaignListResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["PageResultAdminCampaignListResponse"];
        };
        /** @description 后台素材响应 */
        AdminMaterialResponse: {
            /**
             * @description 素材ID
             * @example material_001
             */
            materialId: string;
            /**
             * @description 素材名称
             * @example 春节首充Banner
             */
            materialName: string;
            /**
             * @description 素材类型
             * @example banner
             */
            materialType: string;
            /**
             * @description 素材类型显示名称
             * @example Banner
             */
            materialTypeDisplayName: string;
            /**
             * @description 图片链接
             * @example https://cdn.example.com/banner.jpg
             */
            materialImg: string;
            /**
             * @description 文字标题
             * @example 春节首充活动
             */
            materialTitle: string;
            /**
             * @description 文字描述
             * @example 充值即送200%奖励
             */
            materialDesc: string;
            /**
             * @description 跳转链接
             * @example https://example.com/deposit
             */
            materialUrl: string;
            /**
             * @description 状态
             * @example active
             */
            status: string;
            /**
             * @description 状态显示名称
             * @example 启用
             */
            statusDisplayName: string;
            /**
             * @description 创建人
             * @example admin@example.com
             */
            createdBy: string;
            /**
             * Format: date-time
             * @description 创建时间
             */
            createdAt: string;
            /**
             * Format: date-time
             * @description 更新时间
             */
            updatedAt: string;
        };
        SingleResponseAdminMaterialResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["AdminMaterialResponse"];
        };
        SingleResponseListAdminMaterialResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["AdminMaterialResponse"][];
        };
        SingleResponseVoid: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: Record<string, never>;
        };
        /** @description 返佣提现请求 */
        AffiliateWithdrawRequest: {
            /** @description 提现金额 */
            amount: number;
        };
        SingleResponseAffiliateWithdrawResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["AffiliateWithdrawResponse"];
        };
        /** @description 提现响应 */
        AffiliateWithdrawResponse: {
            /** @description 提现订单号 */
            withdrawOrderNo: string;
            /** @description 提现状态 */
            status: string;
        };
        /** @description 固定奖励列表查询请求（带分页） */
        AffiliateTotalWagerRewardsQueryRequest: {
            /**
             * Format: int32
             * @description 页码
             * @example 1
             */
            pageNum: number;
            /**
             * Format: int32
             * @description 每页数量
             * @example 20
             */
            pageSize: number;
            /** @description 邀请码 */
            inviteCode: string;
            /** @description 用户名模糊查询 */
            username: string;
            /**
             * Format: int64
             * @description 注册开始时间（UTC毫秒）
             */
            registrationStartTime: number;
            /**
             * Format: int64
             * @description 注册结束时间（UTC毫秒）
             */
            registrationEndTime: number;
        };
        SingleResponsePageResultTotalWagerRewardItem: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["PageResultTotalWagerRewardItem"];
        };
        /** @description 分页结果 */
        PageResultTotalWagerRewardItem: {
            /**
             * Format: int64
             * @description 当前页
             */
            current: number;
            /**
             * Format: int64
             * @description 每页数量
             */
            size: number;
            /**
             * Format: int64
             * @description 总记录数
             */
            total: number;
            /** @description 数据列表 */
            records: components["schemas"]["TotalWagerRewardItem"][];
        };
        /** @description 固定奖励项 */
        TotalWagerRewardItem: {
            /** @description 用户名（脱敏） */
            username: string;
            /**
             * Format: int64
             * @description 用户ID
             */
            userId: number;
            /**
             * Format: int64
             * @description 注册时间（UTC毫秒）
             */
            registrationTime: number;
            /** @description 总有效投注额 */
            totalWager: number;
            /** @description 邀请码 */
            inviteCode: string;
            /** @description 累计已赚取 */
            totalEarned: number;
        };
        /** @description 好友佣金贡献查询请求（带分页） */
        AffiliateCommissionByFriendsQueryRequest: {
            /**
             * Format: int32
             * @description 页码
             * @example 1
             */
            pageNum: number;
            /**
             * Format: int32
             * @description 每页数量
             * @example 20
             */
            pageSize: number;
            /** @description 邀请码 */
            inviteCode: string;
            /** @description 用户名模糊查询 */
            username: string;
            /**
             * Format: int64
             * @description 注册开始时间（UTC毫秒）
             */
            registrationStartTime: number;
            /**
             * Format: int64
             * @description 注册结束时间（UTC毫秒）
             */
            registrationEndTime: number;
            /**
             * Format: int64
             * @description 下注开始时间（UTC毫秒）
             */
            wagerStartTime: number;
            /**
             * Format: int64
             * @description 下注结束时间（UTC毫秒）
             */
            wagerEndTime: number;
        };
        SingleResponsePageResultCommissionByFriendItem: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["PageResultCommissionByFriendItem"];
        };
        /** @description 分页结果 */
        PageResultCommissionByFriendItem: {
            /**
             * Format: int64
             * @description 当前页
             */
            current: number;
            /**
             * Format: int64
             * @description 每页数量
             */
            size: number;
            /**
             * Format: int64
             * @description 总记录数
             */
            total: number;
            /** @description 数据列表 */
            records: components["schemas"]["CommissionByFriendItem"][];
        };
        /** @description 好友佣金贡献项 */
        CommissionByFriendItem: {
            /** @description 用户名（脱敏后的下级账户名称） */
            username: string;
            /**
             * Format: int64
             * @description 用户ID，唯一标识便于对账
             */
            userId: number;
            /**
             * Format: int64
             * @description 注册时间（UTC毫秒）
             */
            registrationTime: number;
            /** @description 注册日期展示，格式 yyyy-MM-dd HH:mm:ss */
            registrationDate: string;
            /** @description 邀请码 */
            inviteCode: string;
            /** @description 总有效投注额（美元，Total Wager $） */
            totalWager: number;
            /** @description 佣金比例（创建代码时的比例） */
            commissionRate: number;
            /** @description 累计佣金（该好友自注册以来为邀请人贡献的总佣金，美元） */
            totalCommission: number;
        };
        SingleResponseAffiliateRateRulesConfigResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["AffiliateRateRulesConfigResponse"];
        };
        /** @description 比率与规则配置响应 */
        AffiliateRateRulesConfigResponse: {
            /** @description 当前佣金比率 */
            currentCommissionRate: number;
            /** @description 固定奖励金额汇总（Referral Rewards） */
            referralRewardsTotal: number;
            /** @description 固定奖励阶梯 */
            fixedRewardTiers: components["schemas"]["FixedRewardTier"][];
        };
        /** @description 固定奖励阶梯项 */
        FixedRewardTier: {
            /** @description 有效投注阈值 */
            threshold: number;
            /** @description 固定奖励金额 */
            rewardAmount: number;
        };
        SingleResponseAffiliateMyRewardsSummaryResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["AffiliateMyRewardsSummaryResponse"];
        };
        /** @description 我的奖励汇总响应 */
        AffiliateMyRewardsSummaryResponse: {
            /** @description 可提现总奖励（可提现佣金+可提现推荐奖励） */
            availableReward: number;
            /** @description 总奖励（总佣金+总推荐奖励，含已提现+可提现） */
            totalReward: number;
            /** @description 总佣金（含已提现+可提现） */
            totalCommission: number;
            /** @description 总推荐奖励（已解锁，含已提现+可提现） */
            totalReferral: number;
            /** @description 总提现金额 */
            totalWithdraw: number;
            /** @description 币种 */
            currency: string;
        };
        SingleResponseAffiliateLiveRewardsResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["AffiliateLiveRewardsResponse"];
        };
        /** @description 滚屏奖励响应 */
        AffiliateLiveRewardsResponse: {
            /** @description 累计发放总额 */
            totalPaidAmount: number;
            /** @description 滚屏记录 */
            items: components["schemas"]["LiveRewardItem"][];
        };
        /** @description 滚屏记录项 */
        LiveRewardItem: {
            /** @description 脱敏用户名 */
            usernameMasked: string;
            /** @description 奖励金额 */
            amount: number;
            /** @description 币种 */
            currency: string;
            /**
             * Format: int64
             * @description 时间（UTC毫秒）
             */
            eventTime: number;
        };
        SingleResponseAffiliateInviteCodeStatsResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["AffiliateInviteCodeStatsResponse"];
        };
        /** @description 邀请码统计响应（Referral Codes） */
        AffiliateInviteCodeStatsResponse: {
            /** @description 邀请码列表（Name、Code、Link、Commission Rate、Date Created、Commission Rewards、Referral Rewards、Referrals） */
            items: components["schemas"]["Item"][];
        };
        /** @description 邀请码统计项 */
        Item: {
            /** @description 名称（Campaign Name），未命名时展示 -- */
            name: string;
            /** @description 邀请码，8 位字母数字 */
            inviteCode: string;
            /** @description 推广链接（完整 URL） */
            inviteLink: string;
            /** @description 佣金比例，如 0.25 表示 25% */
            commissionRate: number;
            /** @description 阶梯奖励规则版本 */
            rewardRuleVersion: string;
            /**
             * Format: int64
             * @description 创建时间（UTC毫秒）
             */
            createTime: number;
            /** @description 创建时间展示，格式 yyyy-MM-dd HH:mm:ss */
            dateCreated: string;
            /** @description 该渠道累计佣金（可提现+已提现），货币+数值由前端展示 */
            commissionRewards: number;
            /** @description 该渠道累计推荐奖励（好友总投注额对应奖励），货币+数值由前端展示 */
            referralRewards: number;
            /**
             * Format: int32
             * @description 该邀请码带来的成功注册人数（Referrals）
             */
            referrals: number;
        };
        SingleResponseAffiliateDashboardSummaryResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["AffiliateDashboardSummaryResponse"];
        };
        /** @description Dashboard汇总响应 */
        AffiliateDashboardSummaryResponse: {
            /** @description 总奖励 */
            totalReward: number;
            /**
             * Format: int32
             * @description 好友总数
             */
            totalFriends: number;
            /** @description 推荐奖励总计 */
            referralRewards: number;
            /** @description 佣金奖励总计 */
            commissionRewards: number;
            /** @description 展示币种 */
            currency: string;
        };
        SingleResponseUseRedemptionCodeResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["UseRedemptionCodeResponse"];
        };
        /** 成功返回 */
        UseRedemptionCodeResponse: {
            /** 奖励类型 Bonus, Cash */
            rewardType: string;
            /** 奖励额度 */
            rewardAmount: number;
            /** 币种代码 */
            currencyCode: string;
        };
        /** 使用验证码请求参数 */
        UseRedemptionCodeRequest: {
            /** 兑换码 */
            code: string;
            /**
             * 验证值
             * @description 前端回传的 g-recaptcha-response 或 token
             */
            recaptchaResponse?: string;
            /**
             * 验证版本
             * @description 人机验证版本：v2 / v3（为空默认按 v3）
             */
            captchaVersion?: string;
            /**
             * @description Redis captcha key
             * @example verify:image:captcha:abc123
             */
            captchaKey: string;
            /** Format: int32 */
            xcoordinate?: number;
        };
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
    updateCampaignPremiumStartUpdate: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AdminCampaignUpdateRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseAdminCampaignResponse"];
                };
            };
        };
    };
    createInternalCampaignCheckEligibility: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CampaignEligibilityCheckRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseCampaignEligibilityCheckResponse"];
                };
            };
        };
    };
    createCampaignRewardPreview: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["RewardPreviewRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseRewardPreviewResponse"];
                };
            };
        };
    };
    createCampaignParticipate: {
        parameters: {
            query: {
                /** @description 活动ID */
                campaignId: string;
                /** @description 充值订单ID */
                depositId: string;
                /** @description 充值金额 */
                depositAmount: string;
                /** @description 充值币种 */
                currency: string;
            };
            header: {
                /** @description 用户ID */
                userId: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseString"];
                };
            };
        };
    };
    createPremiumStartEnableByCampaignId: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description 活动ID */
                campaignId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseAdminCampaignResponse"];
                };
            };
        };
    };
    createPremiumStartDisableByCampaignId: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description 活动ID */
                campaignId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseAdminCampaignResponse"];
                };
            };
        };
    };
    createCampaignPremiumStartCreate: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AdminCampaignCreateRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseAdminCampaignResponse"];
                };
            };
        };
    };
    createCampaignParticipationQuery: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AdminCampaignParticipationQueryRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseListUserCampaignParticipationResponse"];
                };
            };
        };
    };
    getCampaignAvailable: {
        parameters: {
            query: {
                /** @description 触发事件（deposit_page-充值页, lobby_enter-大厅, deposit_success-充值成功） */
                triggerEvent: string;
                displayType?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    getCampaignPremiumStartByCampaignId: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description 活动ID */
                campaignId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseAdminCampaignDetailResponse"];
                };
            };
        };
    };
    deleteCampaignPremiumStartByCampaignId: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description 活动ID */
                campaignId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    getCampaignPremiumStartList: {
        parameters: {
            query: {
                request: components["schemas"]["AdminCampaignQueryRequest"];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponsePageResultAdminCampaignListResponse"];
                };
            };
        };
    };
    getCampaignMaterialByMaterialId: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description 素材ID */
                materialId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseAdminMaterialResponse"];
                };
            };
        };
    };
    getMaterialListAvailable: {
        parameters: {
            query?: {
                /** @description 素材类型（banner-横幅, popup-弹窗, icon-图标） */
                materialType?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseListAdminMaterialResponse"];
                };
            };
        };
    };
    createCampaignAffiliateWithdraw: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AffiliateWithdrawRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseAffiliateWithdrawResponse"];
                };
            };
        };
    };
    createCampaignAffiliateTotalWagerRewards: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AffiliateTotalWagerRewardsQueryRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponsePageResultTotalWagerRewardItem"];
                };
            };
        };
    };
    createCampaignAffiliateCommissionByFriends: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AffiliateCommissionByFriendsQueryRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponsePageResultCommissionByFriendItem"];
                };
            };
        };
    };
    getCampaignAffiliateRateRulesConfig: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseAffiliateRateRulesConfigResponse"];
                };
            };
        };
    };
    getAffiliateMyRewardsSummary: {
        parameters: {
            query?: {
                currency?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseAffiliateMyRewardsSummaryResponse"];
                };
            };
        };
    };
    getCampaignAffiliateLiveRewards: {
        parameters: {
            query?: {
                currency?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseAffiliateLiveRewardsResponse"];
                };
            };
        };
    };
    getCampaignAffiliateInviteCodeStats: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseAffiliateInviteCodeStatsResponse"];
                };
            };
        };
    };
    getAffiliateDashboardSummary: {
        parameters: {
            query?: {
                currency?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseAffiliateDashboardSummaryResponse"];
                };
            };
        };
    };
    createCampaignRedemptionCodeUseRedemptionCode: {
        parameters: {
            query?: never;
            header?: {
                "X-Device-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UseRedemptionCodeRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseUseRedemptionCodeResponse"];
                };
            };
        };
    };
}
export enum ApiPaths {
    updateCampaignPremiumStartUpdate = "/admin/campaign/premium-start/update",
    createInternalCampaignCheckEligibility = "/api/promotion/internal/campaign/check-eligibility",
    createCampaignRewardPreview = "/api/campaign/reward/preview",
    createCampaignParticipate = "/api/campaign/participate",
    createPremiumStartEnableByCampaignId = "/admin/campaign/premium-start/enable/{campaignId}",
    createPremiumStartDisableByCampaignId = "/admin/campaign/premium-start/disable/{campaignId}",
    createCampaignPremiumStartCreate = "/admin/campaign/premium-start/create",
    createCampaignParticipationQuery = "/admin/campaign/participation/query",
    getCampaignAvailable = "/api/campaign/available",
    getCampaignPremiumStartByCampaignId = "/admin/campaign/premium-start/{campaignId}",
    deleteCampaignPremiumStartByCampaignId = "/admin/campaign/premium-start/{campaignId}",
    getCampaignPremiumStartList = "/admin/campaign/premium-start/list",
    getCampaignMaterialByMaterialId = "/admin/campaign/material/{materialId}",
    getMaterialListAvailable = "/admin/campaign/material/list/available",
    createCampaignAffiliateWithdraw = "/api/campaign/affiliate/withdraw",
    createCampaignAffiliateTotalWagerRewards = "/api/campaign/affiliate/total-wager-rewards",
    createCampaignAffiliateCommissionByFriends = "/api/campaign/affiliate/commission-by-friends",
    getCampaignAffiliateRateRulesConfig = "/api/campaign/affiliate/rate-rules-config",
    getAffiliateMyRewardsSummary = "/api/campaign/affiliate/my-rewards/summary",
    getCampaignAffiliateLiveRewards = "/api/campaign/affiliate/live-rewards",
    getCampaignAffiliateInviteCodeStats = "/api/campaign/affiliate/invite/code/stats",
    getAffiliateDashboardSummary = "/api/campaign/affiliate/dashboard/summary",
    createCampaignRedemptionCodeUseRedemptionCode = "/api/campaign/redemptionCode/useRedemptionCode"
}
